export const AuthActionTypes = {
	FETCH_PROCESS_TOKEN_REQUEST: '@auth/FETCH_PROCESS_TOKEN_REQUEST',
	FETCH_PROCESS_TOKEN_SUCCESS: '@auth/FETCH_PROCESS_TOKEN_SUCCESS',
	FETCH_PROCESS_TOKEN_ERROR: '@auth/FETCH_PROCESS_TOKEN_ERROR',
};

export interface AuthState {
	auth: AuthStateInfo;
}

export type AuthStateInfo = {
	accessToken: string;
};
